const THRESHOLD = 240

let root = null
let visible = false
let unsubscribe = null

function getRoot() {
  return document.querySelector('.encore-up')
}

function setVisible(next) {
  if (!root || next === visible) return
  visible = next
  root.classList.toggle('is-visible', visible)
}

function bindScroll() {
  const lenis = window.lenis

  unsubscribe?.()
  unsubscribe = null

  if (!lenis) return

  unsubscribe = lenis.on('scroll', (instance) => {
    setVisible(instance.scroll > THRESHOLD)
  })
}

export function initBackToTop() {
  root = getRoot()
  const button = root?.querySelector('[data-encore-up-button]')

  if (!root || !button || root.dataset.backToTopReady === 'true') return

  root.dataset.backToTopReady = 'true'
  visible = false

  button.addEventListener('click', () => {
    window.lenis?.scrollTo(0, { immediate: false })
  })

  bindScroll()
}

export function refreshBackToTop() {
  if (!getRoot()?.dataset.backToTopReady) return

  root = getRoot()
  visible = false
  root?.classList.remove('is-visible')
  bindScroll()
}
